import {
  ClaimsCEsContactParams,
  ClaimsCEsGetParams
} from '@module-claims/models/claim-ce.interface';

export class Get340BAuditClaimsCEs {
  static readonly type = '[ Claim CE ] Get340BAuditClaimsCEs';
  constructor(public params: ClaimsCEsGetParams) {}
}

export class Clear340BAuditClaimsCEs {
  static readonly type = '[ Claim CE ] Clear340BAuditClaimsCEs';
}

export class Contact340BAuditClaimsCEs {
  static readonly type = '[ Claim CE ] Contact340BAuditClaimsCEs';
  constructor(public params: ClaimsCEsContactParams) {}
}

export class Contact340BAuditClaimsCEsModalClose {
  static readonly type = '[ Claim CE ] Contact340BAuditClaimsCEsModalClose';
}

export class Contact340BAuditClaimsCEsModalSave {
  static readonly type = '[ Claim CE ] Contact340BAuditClaimsCEsModalSave';
  constructor(public params: ClaimsCEsContactParams) {}
}
